<template>
    <div>
        <div class="container container-mob" >
            <h1 class="section-head" data-aos="zoom-in" data-aos-duration="1500">{{$t('message.about_management')}}</h1>

        </div>
        <div class="container " >
        <div class="section-p">
                <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;">
                    {{$t('message.aboutfull_1')}}
                </p>
                <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;">
                    {{$t('message.aboutfull_2')}}
                </p>
            </div>
            <div class="container text-center section-div section-four" data-aos="fade-up" data-aos-duration="1000">
                <h1 class="section-head">{{$t('message.about0')}}</h1>
                <div class="row">
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/education.svg" alt="" data-aos="zoom-in"
                             data-aos-duration="1500">
                        <h5>{{$t('message.about1')}}</h5>
                        <p>{{$t('message.about11')}}</p>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/reconstruct.svg" alt="" data-aos="zoom-in"
                             data-aos-duration="1750">
                             <h5>{{$t('message.about2')}}</h5>
                        <p>{{$t('message.about21')}}</p>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/investment.svg" alt="" data-aos="zoom-in"
                             data-aos-duration="2000">
                             <h5>{{$t('message.about3')}}</h5>
                        <p>{{$t('message.about31')}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/effective.svg" alt="" data-aos="zoom-in"
                             data-aos-duration="2250">
                             <h5>{{$t('message.about4')}}</h5>
                        <p>{{$t('message.about41')}}</p>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/team.svg" alt="" data-aos="zoom-in" data-aos-duration="2500">
                        <h5>{{$t('message.about5')}}</h5>
                        <p>{{$t('message.about51')}}</p>
                    </div>
                    <div class="col-sm-4 text-center">
                        <img src="/static/images/icons/develop.svg" alt="" data-aos="zoom-in" data-aos-duration="3000">
                        <h5>{{$t('message.about6')}}</h5>
                        <p>{{$t('message.about61')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact-us'
    }
</script>

<style>
    .container-mob {
        padding-top: 100px;
        display: flex;
    }
</style>
